import { CloudOff } from 'lucide-react';
import { useT } from '@/shared/i18n/useT';
import { Icon } from '../icons/Icon';

export type ConnectionState = 'online' | 'offline' | 'apiDown';

/** Estado de la conexión en la barra superior: solo aparece cuando algo falla (no ensucia lo normal). */
export function ConnectionStatus({ state }: { state: ConnectionState }) {
  const { t } = useT();
  if (state === 'online') return null;
  const text = state === 'offline' ? t('states.offlineShort') : t('states.apiDown');
  return (
    <span
      role="status"
      aria-label={`${t('aria.connection')}: ${text}`}
      className="flex h-9 items-center gap-1.5 rounded-md bg-warn-tint px-2 text-xs font-semibold text-warn"
    >
      <Icon icon={CloudOff} size={16} />
      <span className="hidden sm:inline">{text}</span>
    </span>
  );
}
